var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { buildInputPropsFromContext } from './utils/buildInputPropsFromContext';
import { v4 } from 'uuid';
/**
 * StepContainers are used to isolate the step package from the rest of the application.
 * A Step has a few events:
 * - initialize (constructor) - this will setup the infrastructure (logger, broker, config, package)
 * - run - can be called multiple times with new properties
 * - dispose - used to dispose/stop the step.
 */
var StepContainer = /** @class */ (function () {
    function StepContainer(context, stepPackage, config, logger) {
        var _this = this;
        this.context = context;
        this.handlePackageEventTriggered = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: 
                    // TODO: Validate event against schema
                    return [4 /*yield*/, ((_a = this.onEventTriggered) === null || _a === void 0 ? void 0 : _a.call(this, event))];
                    case 1:
                        // TODO: Validate event against schema
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        }); };
        var schema = stepPackage.schema;
        this.inputProps = buildInputPropsFromContext(context, config, schema.props);
        var StepModule = stepPackage.module;
        this.packageInstance = new StepModule(logger);
        this.packageInstance.onEventTriggered = this.handlePackageEventTriggered;
        // eslint-disable-next-line
        this.instanceId = v4();
    }
    StepContainer.prototype.run = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.packageInstance.run(this.context, this.inputProps)];
            });
        });
    };
    StepContainer.prototype.dispose = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.packageInstance.dispose()];
            });
        });
    };
    return StepContainer;
}());
export { StepContainer };
//# sourceMappingURL=StepContainer.js.map